const KEY = "landoo.favourites";

function read(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(list) ? list.filter((i): i is string => typeof i === "string") : [];
  } catch {
    return [];
  }
}

function write(list: string[]) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, JSON.stringify(list));
}

export function listFavourites(): string[] {
  return read();
}

export function isFavourite(id: string): boolean {
  return read().includes(id);
}

/** Toggles the favourite and returns the new state. */
export function toggleFavourite(id: string): boolean {
  const list = read();
  const next = list.includes(id) ? list.filter((i) => i !== id) : [...list, id];
  write(next);
  return next.includes(id);
}
